import api from "./Api";

class VendasCupomItemService {
  PutVendasCupomItemEdicao(payload) {
    return api.put("/v1/vendasCupomItem/Edicao/", payload).then((response) => {
      return response.data;
    });
  }

  GetVendasCupomItemOData(payload) {
    return api.get("/OData/VendasCupomItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VendasCupomItemService();
